var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:icons' to update
import Icon from '../icon-internal';
function Redo(_a) {
    var size = _a.size, restProps = __rest(_a, ["size"]);
    return (_jsx(Icon, __assign({ viewBox: "0 0 18 18", size: size }, restProps, { children: _jsx("path", { fill: "currentColor", d: "m12.779 5.508-1.855.7c-.518.196-.78.775-.587 1.292a.998.998 0 0 0 1.289.584l3.643-1.377c.4-.15.66-.538.65-.965l-.093-3.694a.998.998 0 0 0-1.027-.974 1.006 1.006 0 0 0-.975 1.03l.044 1.721a7.663 7.663 0 0 0-.107-.085C10.357 1.357 5.67 2.176 3.296 5.57.92 8.962 1.753 13.644 5.157 16.027c3.404 2.384 8.089 1.565 10.465-1.828.268-.457.133-.875-.407-1.253-.54-.377-.951-.343-1.235.104l-.002-.002c-1.742 2.489-5.178 3.089-7.674 1.341-2.496-1.748-3.107-5.181-1.365-7.67 1.743-2.488 5.178-3.088 7.674-1.34.065.045.12.088.166.129Z" }) })));
}
export default Redo;
